<template>
    <vs-card class="w-11/12 shadow-lg">
        <action-bar class="action-bar">
            <template v-slot:left>
                <h2>Coupons</h2>
            </template>
            <template v-slot:right>
                <vx-action-icon
                    :icon="'PlusSquareIcon'"
                    :tooltip="'Add Coupon'"
                    @click="$router.push('/coupons/new')"
                >
                </vx-action-icon>
            </template>
        </action-bar>

        <vx-server-side-table
            class="px-4"
            ref="servertable"
            search
            v-model="selected"
            :fetchData="$api.coupon.fetchCoupons"
            :columns="columns"
            :filters.sync="filters"
        >
            <template v-slot:couponTypeId="{ row }">
                <div>{{ row.couponTypeId == 1 ? 'Corporate' : 'Discount' }}</div>
            </template>
        </vx-server-side-table>
    </vs-card>
</template>

<script>
import CrmContent from '@/components/custom/CrmContent'
import ActionBar from '@/components/custom/ActionBar'

import { mapParams } from '@/plugins/mappers'

export default {
    name: 'coupons',
    components: {
        CrmContent,
        ActionBar
    },
    data() {
        return {
            filters: {
                search: ''
            },
            coupons: [],
            selectedx: null
        }
    },
    computed: {
        ...mapParams('coupon_id'),
        columns() {
            return [
                { title: 'Type', sort: 'type', value: 'couponTypeId', slotName: 'couponTypeId' },
                { title: 'Code', sort: 'code', value: 'code' },
                { title: 'Description', sort: 'description', value: 'description' }
            ]
        },
        selected: {
            get() {
                return this.selectedx
            },
            set(val) {
                // console.log('selected: ' + val.id)
                this.selectedx = val
                // console.log(`coupon_id: ${this.selectedx.id}`)
                // this.coupon_id = val ? val.couponID : null
                this.$router.push(`/coupons/${val.id}`)
            }
        }
    },
    watch: {
        // coupon_id: {
        //     handler: function (val) {
        //         if (!val) {
        //             this.selectedx = null
        //         }
        //     },
        //     immediate: true
        // }
    },
    methods: {}
}
</script>

<style scoped>
h2 {
    color: #6a6e6e;
}
::v-deep .vs-card--content {
    min-height: 40vh;
}
</style>
